var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".arrow-line{fill:none;stroke:#9d9d9d;stroke-miterlimit:10;stroke-width:2.5px;}")),React.createElement("line",{"className":"arrow-line","y1":"12.83588","x2":"56.664","y2":"12.83588","key":1}),React.createElement("path",{"className":"arrow-line","d":"M44.713.88388l11.952,11.952-11.952,11.952","key":2})]);
}

Arrow.defaultProps = {"viewBox":"0 0 58.43274 25.67176"};

module.exports = Arrow;

Arrow.default = Arrow;
